import React from 'react';
import { Box, PageContent, Stack } from 'bumbag';

import LayoutPage from 'legacy/components/checkout/layout/Page';
import RedirectCountdown from 'legacy/components/checkout/RedirectCountdown';
import CompletedTransactionMessage from 'legacy/components/CompletedTransactionMessage';
import { getKeyFromQueryParams } from 'legacy/utils/router';

import { TRANSACTION_ACTIONS } from '../../constants';
type Props = {};
type State = {
  returnUrl?: string;
};
export default class Rejected extends React.PureComponent<Props, State> {
  state = {
    returnUrl: getKeyFromQueryParams('returnUrl'),
  };
  render = () => {
    const { returnUrl } = this.state;
    return (
      <LayoutPage title="Approval rejected">
        <PageContent breakpoint="checkout">
          <Stack spacing="major-2">
            <CompletedTransactionMessage type={TRANSACTION_ACTIONS.REJECTED} />
            {returnUrl && (
              <Box textAlign="center">
                <RedirectCountdown redirectUrl={returnUrl} />
              </Box>
            )}
          </Stack>
        </PageContent>
      </LayoutPage>
    );
  };
}
